module.exports = __webpack_public_path__ + "img/IMG_9432_FoamcoreMatted.486d2d02.jpg";